import { useEffect } from 'react';
import type { LectRelevantTransferOfUsesResponse } from 'src/apis/contract-management/types';
import type { LectTerminationConsequencesRequest } from 'src/apis/contract-management/use-lect-termination-consequences';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  lectTerminationConsequences: LectTerminationConsequencesRequest;
};

export function useLectRelevantTransferOfUses({
  lectTerminationConsequences,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: { url: string }) =>
      axios.request<LectRelevantTransferOfUsesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!lectTerminationConsequences.response) return;
    const url =
      lectTerminationConsequences.response.data._links.relevantTransfersOfUse
        .href;
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [lectTerminationConsequences.response]);

  return request;
}

export type LectRelevantTransferOfUsesRequest = ReturnType<
  typeof useLectRelevantTransferOfUses
>;
